import { Save } from "lucide-react";
import { formatAmount } from "@/lib/utils/formatters";
import { EditIconButton } from "@/components/ui/EditIconButton";
import styles from "../../styles/applicationDetail.module.css";
import type { VerifiedIncomeSectionProps } from "../../types/tabs";

export function VerifiedIncomeSection({
  isEditingVerifiedIncome,
  verifiedIncomeValue,
  savingVerifiedIncome,
  underwriterVerifiedIncome,
  canEditVerifiedIncome,
  onVerifiedIncomeValueChange,
  onSaveVerifiedIncome,
  onStartEdit,
}: VerifiedIncomeSectionProps) {
  const displayAmount =
    underwriterVerifiedIncome != null &&
    underwriterVerifiedIncome !== 0 &&
    Number.isFinite(underwriterVerifiedIncome)
      ? formatAmount(underwriterVerifiedIncome)
      : "";

  return (
    <div
      className={styles.verifiedIncomeSection}
      data-testid="application-income-tab-verified-income-summary"
    >
      <p className={styles.verifiedIncomeReference}>
        Verified Income:{" "}
        {!isEditingVerifiedIncome ? (
          <span className={styles.verifiedIncomeInlineValue}>
            {displayAmount}
            {canEditVerifiedIncome ? (
              <EditIconButton
                data-testid="application-income-tab-edit-verified-income-button"
                onClick={onStartEdit}
                iconClassName="h-3.5 w-3.5"
                className="ml-0.5"
              />
            ) : null}
          </span>
        ) : (
          <span className={styles.inlineEdit}>
            <input
              id="application-income-tab-verified-income-input"
              type="text"
              inputMode="decimal"
              className={styles.inlineInput}
              value={verifiedIncomeValue}
              data-testid="application-income-tab-verified-income-input"
              onChange={(e) => onVerifiedIncomeValueChange(e.target.value)}
              placeholder="Enter Monthly Amount"
            />
            <button
              type="button"
              className={styles.verifiedIncomeSaveButton}
              data-testid="application-income-tab-save-verified-income-button"
              onClick={onSaveVerifiedIncome}
              disabled={savingVerifiedIncome}
              title="Save"
              aria-label="Save verified income"
            >
              <Save className="h-3.5 w-3.5" aria-hidden="true" />
            </button>
          </span>
        )}
      </p>
    </div>
  );
}
